import Cookies from 'js-cookie';

$(document).ready(function() {
    if(typeof CF !== 'undefined'){
        CF.ready(function() {
            var $formId = $('#CustomerRegisterForm #create_customer').attr('data-cf-form');
            var $myForm = document.querySelector(`form[data-cf-form="${$formId}"]`);
            var cfForm = $myForm.cfForm;

            // Saving cookie
            cfForm.beforeSave(function( event ) {
                if(cfForm.getFieldValue('accepts_privacy')) {
                    console.log("submit");
                    var date = new Date();
                    var days = 7;
                    date.setTime(date.getTime() + (days*24*60*60*1000));
                    Cookies.set('NEWSLETTER_POPUP', 'sent-away', { expires: date });
                }
                

                // Saving date accept privacy and marketing
                var today = new Date();
                var day = today.getDate() + "";
                var month = (today.getMonth() + 1) + "";
                var year = today.getFullYear() + "";
                var hour = today.getHours() + "";
                var minutes = today.getMinutes() + "";
                var seconds = today.getSeconds() + "";

                day = checkZero(day);
                month = checkZero(month);
                year = checkZero(year);
                hour = checkZero(hour);
                minutes = checkZero(minutes);
                seconds = checkZero(seconds);

                function checkZero(data){
                    if(data.length == 1){
                        data = "0" + data;
                    }
                    return data;
                }
                var datePrivacy = day + "/" + month + "/" + year + " " + hour + ":" + minutes + ":" + seconds;
                if(cfForm.getFieldValue('accepts_privacy')) {
                    cfForm.setFieldValue('date_accept_privacy', datePrivacy);
                }
                cfForm.setFieldValue('date_accept_mrktng', datePrivacy);
            });
        });
    }
});